/**
 * Back-to-top button — .site-footer__back-to-top
 * 平滑捲回頁首。reduced-motion 用戶用 instant 跳轉。
 */

// P-H-3：改 import 共用 prefersReducedMotion()（utils/dom.js），去重原 inline matchMedia 判斷。
import { prefersReducedMotion } from './utils/dom.js';

const button = document.querySelector('.site-footer__back-to-top');

if (button) {
  button.addEventListener('click', (e) => {
    e.preventDefault();
    const reduceMotion = prefersReducedMotion();
    window.scrollTo({
      top: 0,
      behavior: reduceMotion ? 'auto' : 'smooth',
    });
  });
}
